import { render, staticRenderFns } from "./documenti.vue?vue&type=template&id=0124df8f&"
import script from "./documenti.vue?vue&type=script&lang=js&"
export * from "./documenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports